/**
 * Re-exports for the currency-context hooks so consumers can import from the
 * conventional `_hooks/` location. Implementation and JSDoc live on the
 * originals in `_context/CurrencyContext.tsx` to keep the hooks colocated with
 * the provider they consume.
 */
export { useCurrency, useOptionalCurrency } from "../_context/CurrencyContext";
export type { FormatOptions, UseCurrencyResult } from "../_context/CurrencyContext";
